import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import Profile from '../views/Profile';
import Dashboard from '../views/Dashboard';
import Education from '../views/EducationTab';
import FCRegistration from '../views/FCRegistration';
import MCRegistration from '../views/MCRegistration';
import TPORegistration from '../views/TPORegistration';
import TPORegistrationUpdate from '../views/TPORegistrationUpdate';
import Opportunities from '../views/opportunities/Opportunities'
import CreateOpportunity from '../views/opportunities/CreateOpportunity'
import MyRegistration from '../views/MyRegistration';
import Certifications from '../views/Certifications';
import RegisteredUsersList from '../views/admin/RegisteredUsersList';
import TPORegisteredUsers from '../views/admin/TPORegisteredUsers';
import MCRegisteredUsers from '../views/admin/MCRegisteredUsers';
import FCRegisteredUsers from '../views/admin/FCRegisteredUsers';
import UserDetailsAdmin from '../views/admin/UserDetailsAdmin';
import PasswordReset from '../views/PasswordReset';
import TPORegistrationDetails from '../views/TPORegistrationDetails';
import RegistrationFees from '../views/admin/RegistrationFees';
import SubmissionParent from '../views/submissions/SubmissionParent';
import FCRegsSubReviewList from '../views/reviewer/FCRegsSubReviewList';
import FCReviewParent from '../views/reviewer/FCReviewParent';
import MCReviewParent from '../views/reviewer/MCReviewParent';
import TQReviewParent from '../views/reviewer/TQReviewParent';
import TPOUploadAdmin from '../views/admin/TPOUploadAdmin';
import UserReferral from '../views/UserReferral';
import WelcomePage from '../views/WelcomePage';
import UserReferralDetails from '../views/admin/UserReferralDetails';
import TPOHallticket from '../views/TPOHallticket';
import TPOHallticketAdmin from '../views/admin/TPOHallticketAdmin';
import TQRegistration from '../views/TQRegistration';
import TQRegisteredUsers from '../views/admin/TQRegisteredUsers';
import OpportunitiesAdmin from '../views/admin/OpportunitiesAdmin';
import OpportunitiesUsersAdmin from '../views/admin/OpportunitiesUsersAdmin';
import RegistrationHome from '../views/RegistrationHome';

//Existing Design
import MCRoadmaps from '../views/admin/MCRoadmaps';
import TPOAdminResourcePage from '../views/admin/TPOAdminResourcePage';
import TQAdminResourcePage from '../views/admin/TQAdminResourcePage';
import AdminLearningResourcesMainPage from '../views/admin/AdminLearningResourcesMainPage';
import AdminMCListOfResources from '../views/admin/AdminMCListOfResources';
import UserRoadmaps from '../views/roadmap/UserRoadmaps';
import UserRoadmapsRenderAll from '../views/roadmap/UserRoadmapsRenderAll';
import TPOUserResourcePage from '../views/roadmap/TPOUserResourcePage';
import TQUserResourcePage from '../views/roadmap/TQUserResourcePage';
import TPOReportDownloadCountAdmin from '../views/admin/TPOReportDownloadCountAdmin';

//My Learing Path
import MyBookmarksPage from '../views/roadmap/MyBookmarksPage';
import MyArchivesPage from '../views/roadmap/MyArchivesPage';
import MyLearningPathPage from '../views/roadmap/MyLearningPathPage';
import StrengthAndDevelopment from '../views/roadmap/StrengthAndDevelopment';
import MyCustomSection from '../views/roadmap/MyCustomSection';

//Learning Resource - Admin
import LearningPathMainPage from '../views/roadmap/LearningPathMainPage';
import LearningTaxonomies from '../views/learning_resource_admin/LearningTaxonomies'
import TaxonomyConfiguration from '../views/learning_resource_admin/TaxonomyConfiguration'
import EditTaxonomy from '../views/learning_resource_admin/EditTaxonomy'
import Resources from '../views/learning_resource_admin/Resources'
import LearningResourceList from '../views/learning_resource_admin/LearningResourceList'
import StandaloneResources from '../views/learning_resource_admin/StandaloneResources'

//Learning Resource - User
import LearningResourceHome from '../views/learning_resource_user/LearningResourceHome'
import BuildMyLearningPlan from '../views/learning_resource_user/BuildMyLearningPlan'
import UserResourcePage from '../views/learning_resource_user/UserResourcePage'
import BookMarkSection from '../views/learning_resource_user/BookMarkSection'
import ArchiveSection from '../views/learning_resource_user/ArchiveSection'
import MyLearningPath from '../views/learning_resource_user/MyLearningPath'
import StrengthAndDevelopmentAreas from '../views/learning_resource_user/StrengthAndDevelopmentAreas'
import LearningResourceSearch from '../views/learning_resource_user/LearningResourceSearch'

//Institution Group user
import InstitutionGroupReport from '../views/institutionadmin/InstitutionGroupReport';

import SurveyUserHome from '../views/questionnaire/SurveyUserHome';
import SampleQuizUserHome from '../views/questionnaire/SampleQuizUserHome';
import QuestionnaireComp from '../views/questionnaire/QuestionnaireComp';
import QuestionnaireMain from '../views/questionnaire/QuestionnaireMain';

//User Resource Upload - Admin & User
import UserResourceUpload from '../views/learning_resource_user/UserResourceUpload'
import UserSubmittedResource from '../views/learning_resource_admin/UserSubmittedResource'

//Affiliate User Resource - Admin & User
import AffiliateResourceUpload from '../views/affiliate_user/AffiliateResourceUpload'
import PartnerSubmittedModule from '../views/learning_resource_admin/PartnerSubmittedModule'


//About Pages
import AboutCentaTPO from '../views/about/AboutCentaTPO'
import AboutCentaTQ from '../views/about/AboutCentaTQ'
import AboutCentaMC from '../views/about/AboutCentaMC'

//Rewards - Admin & User
import ConfigureRewards from '../views/rewards_admin/ConfigureRewards'
import UserRewardHistory from '../views/rewards_user/UserRewardHistory'
import ActivityLeaderboard from '../views/rewards_user/ActivityLeaderboard'
import LeaderboardMainPage from '../views/rewards_user/LeaderboardMainPage'
import RewardsMainPage from '../views/rewards_admin/RewardsMainPage'


import TpoRegistrationStatus from '../views/admin/TpoRegistrationStatus'

import PostPayment from '../views/PostPayment';

//Resource and Question of the Day 
import ResourceAndQuestionOfTheDay from '../views/admin/ResourceAndQuestionOfTheDay'

//Uploading Hall Ticket Excel File
import AdminHallTicketUpload from '../views/admin/AdminHallTicketUpload'
import AdminHallTicketUploadHistory from '../views/admin/AdminHallTicketUploadHistory'
import AdminHallTicketDetails from '../views/admin/AdminHallTicketDetails'
import AdminHallTicketUpdate from '../views/admin/AdminHallTicketUpdate'
import AdminHallTicket from '../views/admin/AdminHallTicket'

import AdminHallTicketVersion from '../views/admin/AdminHallTicketVersion'

//Purchase Views
import CoursePackageHome from '../views/purchases/CoursePackageHome'
import CoursePackageDetails from '../views/purchases/CoursePackageDetails'
import AdminAddCourseEntity from '../views/admin/AdminAddCourseEntity'
import AdminAddCourseEntityHome from '../views/admin/AdminAddCourseEntityHome'
import AdminViewCourseEntities from '../views/admin/AdminViewCourseEntities'
import AdminUpdateCourseEntities from '../views/admin/AdminUpdateCourseEntities'
import MyPurchaseOrders from '../views/purchases/MyPurchaseOrders'
import AdminPurchaseOrderView from '../views/admin/AdminPurchaseOrderView'
import CoursePackageLanding from '../views/purchases/CoursePackageLanding'


//Institutional & Retal TQ - Coupon Related 
import UserDetailSearch from '../views/PartialTQ/UserDetailSearch'
import AdminCouponHome from '../views/admin/AdminCouponHome'
import AdminAddCoupon from '../views/admin/AdminAddCoupon'
import InstitutionTQRegistrationList from '../views/PartialTQ/InstitutionTQRegistrationList'
import AdminSearchCoupon from '../views/admin/AdminSearchCoupon'
import AdminAddCouponsToInstitution from '../views/admin/AdminAddCouponsToInstitution'
import AdminAddCouponsToRetail from '../views/admin/AdminAddCouponsToRetail'
import AdminViewCoupons from '../views/admin/AdminViewCoupons'
import AdminCouponDetailsForUser from '../views/admin/AdminCouponDetailsForUser'
import AdminCouponAllocationStatus from '../views/admin/AdminCouponAllocationStatus'

//Admin Questionnaire
import AdminQuestionnaireHome from '../views/admin/AdminQuestionnaireHome'
import AdminQuestionnaireDetail from '../views/admin/AdminQuestionnaireDetail'

//Global Settings Admin dashboard
import AdminChangePWADashboardBanner from '../views/admin/AdminChangePWADashboardBanner'

//Semniar Admin dashboard
import AdminSeminarList from '../views/admin/AdminSeminarList'
import AdminSeminarAddChange from '../views/admin/AdminSeminarAddChange'

//Admin App Version PWA
import AdminAppVersion from '../views/admin/AdminAppVersion'

//User TQ update
import TQRegistrationUpdate from '../views/TQRegistrationUpdate'

//Admin Update Currency Exanchage Rate
import AdminUpdateCurrencyExchageRate from '../views/admin/AdminUpdateCurrencyExchangeRate'
//TQ Report Scores Upload
import AdminTqReportHome from '../views/admin/AdminTqReportHome'
import AdminTqReportDetails from '../views/admin/AdminTqReportDetails'

//Admin DashBoard Configuration

import AdminDisplayConfigurationHome from '../views/admin/AdminDisplayConfigurationHome'
import AdminDisplayConfigurationAddUpdate from '../views/admin/AdminDisplayConfigurationAddUpdate' 

//Admin Trigger Email Notification

import AdminTriggerEmailNotification from '../views/admin/AdminTriggerEmailNotification'

//Admin User Import
import AdminUserImport from '../views/admin/AdminUserImport'

//Admin Discounts
import AdminDiscounts from '../views/admin/AdminDiscounts'
import AdminDiscountAddUpdate from '../views/admin/AdminDiscountAddUpdate'

//Admin User Details Update

import AdminUserDetailsUpdate from '../views/admin/AdminUserDetailsUpdate'



class Content extends Component {
  render() {

    return (
    <main id="shrine-products" className="app__content">
      <Route exact path="/portal/app/dashboard" component={Dashboard} />
      <Route exact path="/portal/app/profile" component={Profile} />
      <Route exact path="/portal/app/education" component={Education} />
      <Route exact path="/portal/app/fc_registration" component={FCRegistration} />
      <Route exact path="/portal/app/mc_registration" component={MCRegistration} />
      <Route exact path="/portal/app/tpo_registration" component={TPORegistration} />
      <Route exact path="/portal/app/tpo_registration_update/:cert_part_id" component={TPORegistrationUpdate} />
      <Route exact path="/portal/app/opportunities" component={Opportunities}/>
      <Route exact path="/portal/app/opportunities/new" component={CreateOpportunity}/>
      <Route exact path="/portal/app/my_registrations" component={MyRegistration} />
      <Route exact path="/portal/app/tpo_certification_report" component={Certifications} />
      <Route exact path="/portal/app/reg_users" component={RegisteredUsersList} />
      <Route exact path="/portal/app/tpo_reg_users" component={TPORegisteredUsers} />
      <Route exact path="/portal/app/mc_reg_users" component={MCRegisteredUsers} />
      <Route exact path="/portal/app/fc_reg_users" component={FCRegisteredUsers} />
      <Route exact path="/portal/app/reg_user_details" component={UserDetailsAdmin} />
      <Route exact path="/portal/app/password_reset" component={PasswordReset} />
      <Route exact path="/portal/app/tpo_registration_details" component={TPORegistrationDetails} />
      <Route exact path="/portal/app/registration_fees" component={RegistrationFees} />
      <Route exact path="/portal/app/submission_parent" component={SubmissionParent} />
      <Route exact path="/portal/app/reviewer/fc_parent" component={FCReviewParent} />
      <Route exact path="/portal/app/reviewer/mc_parent" component={MCReviewParent} />
      <Route exact path="/portal/app/reviewer/tq_parent" component={TQReviewParent} />
      <Route exact path="/portal/app/admin/tpo_admin_upload" component={TPOUploadAdmin} />
      <Route exact path="/portal/app/user_referral" component={UserReferral} />
      <Route exact path="/portal/app/welcome_page" component={WelcomePage} />
      <Route exact path="/portal/app/admin_user_referral" component={UserReferralDetails} />
      <Route exact path="/portal/app/tpo_reg_hallticket" component={TPOHallticket} />
      <Route exact path="/portal/app/admin/tpo_hallticket_admin" component={TPOHallticketAdmin} />
      <Route exact path="/portal/app/tq_registration/:name/:type/:partialId" component={TQRegistration} />
      <Route exact path="/portal/app/admin/tq_registration" component={TQRegisteredUsers} />
      <Route exact path="/portal/app/admin/opportunities" component={OpportunitiesAdmin} />
      <Route exact path="/portal/app/admin/opportunity/users" component={OpportunitiesUsersAdmin} />
      <Route exact path="/portal/app/admin/tpo_report/download_count" component={TPOReportDownloadCountAdmin} />

      {/* Existing Design */}
      <Route exact path="/portal/app/mc_roadmap" component={MCRoadmaps} />
      <Route exact path="/portal/app/mc_roadmap/list_of_resources" component={AdminMCListOfResources} />
      {/* <Route exact path="/portal/app/admin/learning_resources" component={AdminLearningResourcesMainPage} />*/}
      <Route exact path="/portal/app/user/learning_path_main_page" component={LearningPathMainPage} />
      <Route exact path="/portal/app/user/mc_roadmaps" component={UserRoadmaps} /> 
      <Route exact path="/portal/app/user/all_mc_roadmaps" component={UserRoadmapsRenderAll} />


      {/* My learning path*/}
      <Route exact path="/portal/app/user/my_bookmarks_section" component={MyBookmarksPage} />
      <Route exact path="/portal/app/user/my_archives_section" component={MyArchivesPage} />
      <Route exact path="/portal/app/user/my_learning_arc_section" component={MyLearningPathPage} /> 
      <Route exact path="/portal/app/user/my_learning/strength_and_areas_of_development" component={StrengthAndDevelopment} />
      {/*<Route exact path="/portal/app/user/my_learning/custom_learning_resources" component={MyCustomSection} />*/}
      
      <Route exact path="/portal/app/instadmin/instgroupreport" component={InstitutionGroupReport} />


      {/* Learning Resources - Admin */}
      <Route exact path="/portal/app/admin/learning_taxonomies" component={LearningTaxonomies} />
      <Route exact path="/portal/app/admin/learning_taxonomies/:type/:typeName" component={TaxonomyConfiguration} />
      <Route exact path="/portal/app/admin/learning_taxonomies/:type/:typeName/edit/:taxonomyId" component={EditTaxonomy} />
      <Route exact path="/portal/app/admin/learning_taxonomies/resources" component={Resources} />
      <Route exact path="/portal/app/admin/render_learning_resources" component={LearningResourceList} />
      <Route exact path="/portal/app/admin/standalone_resources" component={StandaloneResources} />

      {/* Learning Resources - User 
      <Route exact path="/portal/app/build_my_plan" component={LearningResourceHome} />
      <Route exact path="/portal/app/user/resources/:view/:type/:typeName" component={UserResourcePage} />
      <Route exact path="/portal/app/learning_resources/my_learning_plan" component={MyLearningPath} />
      <Route exact path="/portal/app/learning_resources/search/:userType" component={LearningResourceSearch} />
      <Route exact path="/portal/app/user/learning_resources" component={BuildMyLearningPlan} />*/}

      {/* Learning Resource - My Learning Path 
      <Route exact path="/portal/app/user/my_learning_path/my_bookmarks_section" component={BookMarkSection} />
      <Route exact path="/portal/app/user/my_learning_path/my_archives_section" component={ArchiveSection} />
      <Route exact path="/portal/app/user/my_learning_path/my_strength_and_development_areas" component={StrengthAndDevelopmentAreas} />*/}

      {/* Survey and Sample Quiz */}
      <Route exact path="/portal/app/user/survey_user_home" component={SurveyUserHome} />
      <Route exact path="/portal/app/user/samplequiz_user_home" component={SampleQuizUserHome} />
      <Route exact path="/portal/app/user/questionnaire_component/:type/:id" component={QuestionnaireComp} />  
      <Route exact path="/portal/app/user/questionnaires" component={QuestionnaireMain} />
      <Route exact path="/portal/app/user/questionnaire_component/:id" component={QuestionnaireComp} />

      {/* Learning Resource - User Resource Upload - User & Admin */}
      <Route exact path="/portal/app/user/upload_resource" component={UserResourceUpload} />
      <Route exact path="/portal/app/admin/user_resource/submitted_response" component={UserSubmittedResource} />

      {/* Affiliate Partner - Resource Module - User & Admin */}
      <Route exact path="/portal/app/user/affiliate_partner/initiate_module" component={AffiliateResourceUpload} />
      <Route exact path="/portal/app/admin/submitted_modules" component={PartnerSubmittedModule} />

      {/* Registration Home Page */}
      <Route exact path="/portal/app/user/registration_home_page" component={RegistrationHome} />

      {/* About Centa */}
      <Route exact path="/portal/app/user/about/tpo" component={AboutCentaTPO} />
      <Route exact path="/portal/app/user/about/tq" component={AboutCentaTQ} />
      <Route exact path="/portal/app/user/about/mc" component={AboutCentaMC} />

      {/* Rewards - Admin & User */}
      <Route exact path="/portal/app/user/activity_log" component={UserRewardHistory} />
      <Route exact path="/portal/app/admin/leaderboards" component={ActivityLeaderboard} />
      <Route exact path="/portal/app/user/activity_main_page" component={LeaderboardMainPage} />
      <Route exact path="/portal/app/admin/rewards_section" component={RewardsMainPage} />
      
      <Route exact path="/portal/app/post_payment" component={PostPayment} />

      <Route exact path="/portal/app/admin/tpo_registration_status" component={TpoRegistrationStatus} />

      <Route exact path="/portal/app/admin/resource_and_question_of_the_day/:typeName" component={ResourceAndQuestionOfTheDay} />

      {/* Hall Ticket Upload - Admin */}
      <Route exact path="/portal/app/admin/hallticket/upload/:type/:uploadType" component={AdminHallTicketUpload} />
      <Route exact path="/portal/app/admin/hallticket/view/history/:typeId/:uploadType" component={AdminHallTicketUploadHistory} />
      <Route exact path="/portal/app/admin/hallticket/details" component={AdminHallTicketDetails} />
      <Route exact path="/portal/app/admin/hallticket/update/:hallticketId/:userId" component={AdminHallTicketUpdate} />
      <Route exact path="/portal/app/admin/hallticket" component={AdminHallTicket} />
      <Route exact path="/portal/app/admin/hallticket/version/:hallticketId/:userId" component={AdminHallTicketVersion} />

      {/* Purchase View */} 
      <Route exact path="/portal/app/purchase/home/:id" component={CoursePackageHome} />
      <Route exact path="/portal/app/purchase/detail/:packageName/:id" component={CoursePackageDetails} />
      <Route exact path="/portal/app/admin/course/entity" component={AdminAddCourseEntity} />
      <Route exact path="/portal/app/admin/course/entity/home" component={AdminAddCourseEntityHome} />
      <Route exact path="/portal/app/admin/course/entity/list" component={AdminViewCourseEntities} />
      <Route exact path="/portal/app/admin/course/entity/update/:id" component={AdminUpdateCourseEntities} />
      <Route exact path="/portal/app/purchase/orders" component={MyPurchaseOrders} />
      <Route exact path="/portal/app/admin/purchase/view" component={AdminPurchaseOrderView} />
      <Route exact path="/portal/app/purchase/landing" component={CoursePackageLanding} />

      

      {/*Partial TQ - Institutional */}
      <Route exact path="/portal/app/institute/userdetail" component={UserDetailSearch} />
      <Route exact path="/portal/app/admin/coupons" component={AdminCouponHome} />
      <Route exact path="/portal/app/admin/coupons/add" component={AdminAddCoupon} />
      <Route exact path="/portal/app/institute/userdetail_list" component={InstitutionTQRegistrationList} />
      <Route exact path="/portal/app/admin/coupons/search" component={AdminSearchCoupon} />
      <Route exact path="/portal/app/admin/coupons/institution" component={AdminAddCouponsToInstitution} />
      <Route exact path="/portal/app/admin/coupons/view" component={AdminViewCoupons} />
      <Route exact path="/portal/app/admin/coupons/user_details" component={AdminCouponDetailsForUser} />
      <Route exact path="/portal/app/admin/coupons/coupon_allocation_status" component={AdminCouponAllocationStatus} />
      <Route exact path="/portal/app/admin/coupons/retail" component={AdminAddCouponsToRetail} />

      {/*Admin Questionnaire */}
      <Route exact path="/portal/app/admin/questionnaire/home" component={AdminQuestionnaireHome} />
      <Route exact path="/portal/app/admin/questionnaire/detail/:id" component={AdminQuestionnaireDetail} />

      {/* Global Settings Change PWA Dashboard Banner*/}
      <Route exact path="/portal/app/admin/change_pwa_banner" component={AdminChangePWADashboardBanner} />

      {/*Seminar Admin*/}
      <Route exact path="/portal/app/admin/seminar/list" component={AdminSeminarList} />
      <Route exact path="/portal/app/admin/seminar/Change/:id" component={AdminSeminarAddChange} />

      {/*Admin App Version PWA*/}
      <Route exact path="/portal/app/admin/pwa_app_version" component={AdminAppVersion} />

      {/* TQ Registration Update*/}
      <Route exact path="/portal/app/fetch/tq/registration/:cert_part_id" component={TQRegistrationUpdate} />

      {/*Admin Currency Exchagne Rate*/}
      <Route exact path="/portal/app/admin/fetch/currency/exchange/rate" component={AdminUpdateCurrencyExchageRate} />
      {/* Admin TQ Scores Upload*/}
      <Route exact path= "/portal/app/admin/tq/reports/home" component={AdminTqReportHome}/>
      <Route exact path= "/portal/app/admin/tq/report/upload/details" component={AdminTqReportDetails}/>
      
      {/* Admin Display Configuration*/}
      <Route exact path = "/portal/app/admin/display/configuration/home" component={AdminDisplayConfigurationHome}/>
      <Route exact path = "/portal/app/admin/add/update/display/config/:id" component={AdminDisplayConfigurationAddUpdate}/>

      {/* Admin Email Notification */}
      <Route exact path = "/portal/app/admin/initiate/email/notification/:type" component={AdminTriggerEmailNotification}/>

      {/* Admin User Import */}
      <Route exact path = "/portal/app/admin/user/import/home" component={AdminUserImport}/>

      {/*Admin Discounts */}
      <Route exact path = "/portal/app/admin/discounts" component={AdminDiscounts} />
      <Route exact path = "/portal/app/admin/discount/change/:discountId" component={AdminDiscountAddUpdate} />


      {/* Admin User Details Update] */}
      <Route exact path = "/portal/app/admin/user/details/update" component={AdminUserDetailsUpdate}/>

    </main>

   )
  }
}

export default Content;











// WEBPACK FOOTER //
// ./src/layout/Content.jsx